// Xuan Harness brand wordmark: calligraphic X monogram + "Xuan" letterforms +
// HARNESS badge plate in one svg. Native 182x24, same footprint as the
// upstream wordmark it replaces. Ink rides currentColor; the badge text is
// knocked out in the inverted label color so the plate stays legible in both
// themes.

import type { IconProps } from './icons/props.ts'
import { TurbineLogo } from './TurbineLogo.tsx'

/**
 * Render the full brand wordmark.
 * @param props.size - height in px (default 24; width keeps the 182:24 ratio).
 * @param props.className - extra class for layout placement.
 * @returns the wordmark svg (aria-hidden decorative brand art).
 */
export function BrandWordmark({ size = 24, className }: IconProps) {
  return (
    <svg
      width={(size * 182) / 24}
      height={size}
      className={className}
      viewBox="0 0 182 24"
      fill="none"
      aria-hidden="true"
    >
      <g transform="translate(1 1)" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="1" width="20" height="20" rx="6" strokeWidth="1.5" opacity="0.42" />
        <path d="M5 3.7c3.5 1.2 5 4.6 6 7.3 1.2 3.4 3 6.4 6 7.3" strokeWidth="2.25" />
        <path d="M17 3.7c-3.5 1.2-5 4.6-6 7.3-1.2 3.4-3 6.4-6 7.3" strokeWidth="2.25" />
        <path d="m11 8.9 2.1 2.1-2.1 2.1L8.9 11 11 8.9Z" fill="currentColor" stroke="none" />
      </g>
      <text
        x="26"
        y="17"
        fill="currentColor"
        fontFamily="system-ui, 'Segoe UI', sans-serif"
        fontSize="15"
        fontWeight="650"
        letterSpacing="0.2"
      >
        Xuan
      </text>
      <rect x="70" y="4.5" width="108" height="15" rx="7.5" fill="currentColor" />
      <text
        x="124"
        y="15.2"
        textAnchor="middle"
        fill="var(--dsw-alias-label-primary-inverted)"
        fontFamily="system-ui, 'Segoe UI', sans-serif"
        fontSize="9.5"
        fontWeight="700"
        letterSpacing="1.6"
      >
        HARNESS
      </text>
    </svg>
  )
}

// TurbineLogo is re-exported here as well so the wordmark module stays the
// single import site for brand art.
export { TurbineLogo }
